/**
 * WizardProgress
 *
 * Displays overall wizard progress as a percentage bar.
 */

import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

interface WizardProgressProps {
  completed: number;
  total: number;
  percentage: number;
  className?: string;
}

export function WizardProgress({ completed, total, percentage, className }: WizardProgressProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">Progress</span>
        <span className="font-medium">{percentage}%</span>
      </div>
      <Progress value={percentage} className="h-2" />
      <p className="text-xs text-muted-foreground">
        {completed} of {total} steps completed
      </p>
    </div>
  );
}
